module.exports = __webpack_public_path__ + "img/syntax_logo.78b4f2e2.svg";